export type LogMessageFn = (payload: RequestModel) => Promise<void>;

export interface RequestModel {
    message?: string;
    url: string;
    stacktrace?: string;
    logLevel?: 'INFO' | 'WARN' | 'ERROR';
    referrer?: string;
}

export function initLogMessageFn({
    baseUrl,
}: {
    baseUrl: string;
}): LogMessageFn {
    return async (payload: RequestModel) => {
        const url = `${baseUrl}/utility/log-message`;
        const headers = {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json',
            /**
             * Note:
             * Temp solution to stop potential http error from this service being caught by the interceptor code in apps/de-care/src/app/core/services/global-http-interceptor.service.ts
             */
            'X-Skip-Http-Interceptor': 'true',
        };
        const response = await fetch(url, {
            method: 'POST',
            headers,
            credentials: 'include',
            body: JSON.stringify({
                url: payload.url || '/',
                stacktrace: payload.stacktrace,
                message: payload.message || '',
                logLevel: payload.logLevel,
                referrer: payload.referrer,
            }),
        });
        if (!response.ok) return Promise.reject(await response.json());
        return await response.json();
    };
}
